import { Button } from '@/components/ui/button'
import { CheckCircle2, X } from 'lucide-react'

interface FileInfoDisplayProps {
  fileName: string
  rowCount: number
  onRemove: () => void
  isSending: boolean
}

export function FileInfoDisplay({
  fileName,
  rowCount,
  onRemove,
  isSending,
}: FileInfoDisplayProps) {
  return (
    <div className='flex items-center justify-between p-3 bg-gray-50 rounded-lg'>
      <div className='flex items-center gap-2 flex-1 min-w-0'>
        <CheckCircle2 className='h-5 w-5 text-green-500 flex-shrink-0' />
        <span className='text-sm font-medium text-gray-700 truncate'>
          {fileName}
        </span>
        <span className='text-xs text-gray-500'>({rowCount} rows)</span>
      </div>
      {!isSending && (
        <Button
          type='button'
          variant='ghost'
          size='sm'
          onClick={onRemove}
          className='flex-shrink-0'
        >
          <X className='h-4 w-4' />
        </Button>
      )}
    </div>
  )
}

